<template>
    <v-card
        elevation="1"
        :color="color"
        class="mt-4"
    >
        <v-card-text>
            <div class="text--primary">
                {{ value.typeLabel }}
            </div>
            <div v-if="value.device">
                Устройство:
                <router-link :to="`/devices/view/${value.deviceId}`" class="clean-link" @click.native="hideMenu">
                    {{ value.device.name }}
                </router-link>
            </div>
            <div v-else-if="value.extra && value.extra.type === 'deviceEmissions'">
                Устройства:
                <EventExtraDeviceEmissions :value="value" />
            </div>
            <div class="text-right">
                {{ displayTime(value.occurredAt) }}
            </div>
        </v-card-text>
        <v-card-actions v-if="value.isActual" class="pt-0">
            <v-spacer />
            <v-btn text @click="unactualize">
                Не актуально
            </v-btn>
        </v-card-actions>
    </v-card>
</template>


<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject, Prop} from 'vue-property-decorator'
import Api from '@/services/Api'
import {Event, LEVEL_ALERT, LEVEL_INFO, LEVEL_WARNING} from '@/models/Event'
import {displayTime} from '@/utils/datetime'
import EventExtraDeviceEmissions from '@/components/common/EventExtraDeviceEmissions.vue'

@Component({
    components: {EventExtraDeviceEmissions},
    methods: {displayTime},
})
export default class EventCard extends Vue
{
    @Inject('api') private api!: Api

    @Prop({required: true, type: Object})
    value!: Event

    async unactualize() {
        if (this.value.id != null) {
            await this.api.unactualizeEvent(this.value.id)
        }
    }

    get color() {
        const level = this.value.level ?? '-1'

        if (level >= LEVEL_ALERT) {
            return '#f2c2be'
        } else if (level >= LEVEL_WARNING) {
            return '#f1dfbc'
        } if (level >= LEVEL_INFO) {
            return '#bcd8f1'
        }
        return '#d4d4d4'
    }

    hideMenu() {
        this.$emit('hide-menu')
    }
}
</script>
